function Project(data, shape) {
	this.data = data;
	this.shape = shape;
}

Project.prototype.getId = function() {
	return this.data.id;
};

Project.prototype.getName = function() {
	return this.data.name;
};

Project.prototype.getDescription = function({ trim = true }) {
	return trim || typeof trim === 'undefined' && this.data.description.length > 100 ?
		this.data.description.substr(0, 97).trim() + '...' : this.data.description;
};

Project.prototype.getFeaturedImageSrc = function() {
	return this.data.featuredImage ? this.data.featuredImage.src : '';
};

Project.prototype.getStatus = function() {
	return this.data.status;
};

Project.prototype.getStatusLabel = function() {
	return this.data.statusLabel;
};

Project.prototype.getUrl = function() {
	return this.data.url;
};

Project.prototype.getSvgElementTagName = function() {
	return this.shape.elementTagName;
};

Project.prototype.getPointsValueForShape = function() {
	return this.shape.points;
};

Project.prototype.getDValueForShape = function() {
	return this.shape.d;
};

Project.prototype.getWidthValueForShape = function() {
	return this.shape.width;
};

Project.prototype.getHeightValueForShape = function() {
	return this.shape.height;
};

Project.prototype.getXValueForShape = function() {
	return this.shape.x;
};

Project.prototype.getYValueForShape = function() {
	return this.shape.y;
};

Project.prototype.getStatus = function() {
	return this.data.status;
};

export default Project;